import axios from 'axios';

const instance = axios.create({
    baseUrl: "https://todo-backend-504dzpfk3-pavan2108.vercel.app/"
})

export default instance;